import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { get, getWithCancelToken, patch, post, putPresigned } from "../../services/API/ApiClient";
import { FilterValueType } from "./TranscribeSlice";
import { values } from "@fluentui/react";
import axios, { CancelToken, CancelTokenSource } from "axios";

//Get Download PackDetails
export const getDownloadPackdetails = createAsyncThunk<any, any, { state: RootState }>("transcribe/getDownloadPackdetails", async (packId, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await get(`/exports/packs/${packId}`, "Transcribe");
    return response.data.exports;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Download the pack
export const getDownloadPack = createAsyncThunk<any, any, { state: RootState }>("transcribe/getDownloadPack", async (id, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await get(`/exports/${id}/download`, "Transcribe");

    if (response.data.url) {
      const downloadLink = document.createElement("a");
      downloadLink.href = response.data.url;
      downloadLink.download = response.filename || "downloaded-file";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }

    return response.url;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Fetch picklist api

export const getPicklist = createAsyncThunk<any, any, { state: RootState }>("transcribe/getPicklist", async (type, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await get(`/pick-list`, "Transcribe");
    const tenantPicklist = [
      { label: "Organization", value: 0 },
      ...response.Tenants.map((tenant: any) => {
        return { label: tenant.name, value: tenant.id };
      }),
    ];
    const priorityPicklist = [
      { label: "Priority", value: 0 },
      ...response.PriorityTypes.map((priority: any) => {
        return { label: priority.name, value: priority.id };
      }),
    ];
    const transcriptionPicklist = [
      { label: "Type", value: 0 },
      ...response.TranscriptionTypes.map((transcription: any) => {
        return { label: transcription.name, value: transcription.id };
      }),
    ];
    const statusPicklist = [
      { label: "Status", value: 0 },
      ...response.ProcessingStatuses.map((status: any) => {
        return { label: status.name, value: status.id };
      }),
    ];
    return {
      tenantPicklist,
      priorityPicklist,
      transcriptionPicklist,
      statusPicklist,
    };
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const updateUploadProgress = createAction<{
  progress: number;
  fileName: string;
}>("transcribe/updateUploadProgress");

export const updateUploadCancelToken = createAction<{
  cancelToken: CancelTokenSource;
  fileName: string;
}>("transcribe/updateUploadCancelToken");

export const uploadFile = createAsyncThunk<any, any, { state: RootState }>("transcribe/uploadFile", async (args, { signal, getState, dispatch, rejectWithValue }) => {
  const onUploadProgress = (progress: number) => {
    dispatch(updateUploadProgress({ progress: progress, fileName: args.file.name }));
  };
  const cancelTokenSource = axios.CancelToken.source();
  args.cancelUploadRef.current = cancelTokenSource;
  try {
    const response = await getWithCancelToken(`/packs/upload_url?tenantID=${args.data.IdTenant}&fileName=${args.file.name}&packUUID=${args.id}`, "Transcribe", cancelTokenSource.token);
    const uploadUrl = response.data.presignedUrl;
    await putPresigned(uploadUrl, args.file, onUploadProgress, cancelTokenSource.token, args.cancelUploadRef);
    return response.data;
  } catch (e) {
    return rejectWithValue(e);
  }
});
export const createPack = createAsyncThunk<any, any, { state: RootState }>("transcribe/createPack", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await post("/packs/create", "Transcribe", args.data);
    return response.data || response;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const resetUploadProgress = createAction("transcribe/resetUploadProgress");

export const lockAudio = createAsyncThunk<any, any, { state: RootState }>("transcribe/lockAudio", async (id, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await patch(`/packs/${id}/lock`, "Transcribe", {});
    return response;
  } catch (e) {
    return rejectWithValue(e);
  }
});
export const clearFilter = createAction("transcribe/clearFilter");
export const updateFilterValues = createAction<FilterValueType>("transcribe/updateFilterValues");
export const setSearchKeyword = createAction<string>("transcribe/setSearchKeyword");
export const resetFilter = createAction("transcribe/resetFilter");
//Modal
export const openUploadModal = createAction("transcribe/openUploadModal");
export const closeUploadModal = createAction("transcribe/closeUploadModal");

export const openDownloadModal = createAction("transcribe/openDownloadModal");
export const closeDownloadModal = createAction("transcribe/closeDownloadModal");

export const getEmailfromSession = createAction<any>("transcribe/getEmailfromSession");
